import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import API from "../api/API";

const REFRESH_INTERVAL = 60 * 60 * 1000;

type MaintenanceBannerConfig = {
  message: string;
  backgroundColor: string;
  textColor: string;
};

const MaintenanceBanner = () => {
  const [config, setConfig] = useState<MaintenanceBannerConfig | null>(null);

  useEffect(() => {
    let active = true;

    const fetchBanner = async () => {
      try {
        const response = await API.get<MaintenanceBannerConfig | null>(
          "/activation/maintenance-banner",
        );

        if (active) {
          setConfig(response.data);
        }
      } catch {
        // Keep the last successfully loaded banner during transient failures.
      }
    };

    const handleFocus = () => {
      void fetchBanner();
    };

    void fetchBanner();
    const interval = window.setInterval(fetchBanner, REFRESH_INTERVAL);
    window.addEventListener("focus", handleFocus);

    return () => {
      active = false;
      window.clearInterval(interval);
      window.removeEventListener("focus", handleFocus);
    };
  }, []);

  const message = config?.message?.trim() ?? "";
  if (!config || !message) {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: config.backgroundColor,
        color: config.textColor,
        flexShrink: 0,
        zIndex: (theme) => theme.zIndex.appBar + 1,
        textAlign: "center",
        px: 2,
        py: 1,
      }}
    >
      <Typography variant="body2" color="inherit">
        {message}
      </Typography>
    </Box>
  );
};

export default MaintenanceBanner;
